'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _prefix = require('../prefix');

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Support old appearance props syntax.
// https://caniuse.com/#search=appearance
exports['default'] = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (_prefix2['default'].js === 'ms') return '-webkit-' + prop;
    return _prefix2['default'].css + prop;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/css-vendor/lib/plugins/appearence.js
// module id = 7
// module chunks = 0